import React, { useEffect, useState } from 'react';
import pikug from '../assets/images/claim/pikug.svg';
import vepikug from '../assets/images/claim/vepikug.svg';
import error_icon from '../assets/images/claim/erroricon.svg';
import lockedpikug from '../assets/images/claim/lockedpikug.svg';
import useTranslation from "../Languages/Translation";
import { ethers } from "ethers";
import {
    claimPikuG,
    getLockedPikuAmount,
    getLockedPikuTime,
    getPikuBalance,
    getPikuGBalance,
    getVePikuGAmount
} from '../Service/Web3/Web3Service';
import { useWeb3ModalAccount, useWeb3ModalProvider } from '@web3modal/ethers/react';

const Claim = () => {
    const { walletProvider } = useWeb3ModalProvider();
    const { isConnected, address } = useWeb3ModalAccount();

    const translation = useTranslation();
    const [pikuG, setPikuG] = useState("0.00");
    const [vePikuG, setVePikuG] = useState("0.00");
    const [lockedPikuG, setLockedPikuG] = useState("0.00");
    const [earnedPikuG, setEarnedPikuG] = useState("0.00");
    const [lockedTime, setLockedTime] = useState("-");
    const [isLoading, setIsLoading] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [showAlert, setShowAlert] = useState(false);

    useEffect(() => {
        const fetchLockedAmount = async () => {
            const provider = new ethers.BrowserProvider(walletProvider);
            const signer = await provider.getSigner();

            const pikuBalance = await getPikuGBalance(signer, address);
            const vePikugBalance = await getVePikuGAmount(signer);
            const lockedPikuAmount = await getLockedPikuAmount(signer);
            const lockedPikuTime = await getLockedPikuTime(signer);

            if (lockedPikuTime == 0) {
                setLockedTime("-");
            } else {
                const date = new Date(Number(lockedPikuTime) * 1000).toLocaleDateString();
                setLockedTime(date);
            }

            setVePikuG(Number(vePikugBalance).toFixed(2));
            setLockedPikuG(Number(lockedPikuAmount).toFixed(2));
            setPikuG(Number(pikuBalance).toFixed(2));
        };

        if (walletProvider && isConnected) {
            fetchLockedAmount();
        }
    }, [walletProvider, isConnected]);

    const handleClaim = async () => {
        setIsLoading(true);
        try {
            const provider = new ethers.BrowserProvider(walletProvider);
            const signer = await provider.getSigner();
            await claimPikuG(signer);
        } catch (error) {
            console.log(error);
            setAlertMessage('An error occurred while claiming.');
            setShowAlert(true);
            setTimeout(() => {
                setShowAlert(false);
            }, 3000); // Alert will disappear after 3 seconds
        }
        setIsLoading(false);
    };

    const rewardsList = [
        {
            image: pikug,
            asset: "PikuG",
            earned: earnedPikuG,
        }
    ];

    const balancedList = [
        {
            image: pikug,
            asset: "PikuG",
            amount: pikuG,
        },
        {
            image: vepikug,
            asset: "vePikuG",
            amount: vePikuG,
        },
        {
            image: lockedpikug,
            asset: "Locked PikuG",
            amount: lockedPikuG,
        }
    ];

    return (
        <div className=" main_container pt-[90px] lg:pt-[120px]">
            {showAlert && (
                <div className="fixed top-24 left-1/2 transform -translate-x-1/2 bg-[#050505] text-white px-4 py-2 rounded-lg z-50 flex items-center shadow-lg border border-[#222222]">
                    <div className="bg-red-500 rounded-full h-6 w-6 flex items-center justify-center mr-2">
                        <img src={error_icon} alt="error icon" className="w-10 h-10" />
                    </div>
                    <span className="text-lg">{alertMessage}</span>
                </div>
            )}
            <div className='max-w-[520px] mx-auto'>
                <div className='p-[32px] bg-[#222222] rounded-[24px]'>
                    <p className='text-[20px] lg:text-[24px] aeonik_medium text-white leading-[30px]'>{translation.PikuGRewards}</p>
                    <table className='w-[100%] mt-[24px]'>
                        <thead className='rounded-[8px]'>
                            <tr>
                                <th className='text-[#9b9c9d] text-[14px] leading-[18px] rounded-l-[8px] text-left aeonik_medium pl-[12px] bg-[#383A3D] py-[6px]'>ASSET</th>
                                <th className='text-[#9b9c9d] text-[14px] leading-[18px] text-left aeonik_medium bg-[#383A3D] py-[6px]'>EARNED</th>
                                <th className='text-[#383A3D] text-[14px] leading-[18px] bg-[#383A3D] py-[6px] aeonik_medium rounded-r-[8px]'>EARNED</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr><td className='py-[8px]'></td></tr>
                            {rewardsList.map((item, i) => (
                                <tr key={i}>
                                    <td className='flex items-center pt-[14px]'>
                                        <img src={item.image} alt='logo' className='h-[32px] w-auto object-contain mr-[8px]' />
                                        <p className='lg:text-[18px] text-white aeonik_normal leading-[23px]'>{item.asset}</p>
                                    </td>
                                    <td className='pt-[14px]'>
                                        <p className='lg:text-[18px] text-white aeonik_medium leading-[23px]'>{item.earned}</p>
                                    </td>
                                    <td className='pt-[14px] text-end'>
                                        <a className='bg-[#223233] rounded-[6px] px-[16px] py-[6px] '>
                                            <span
                                                className='text-[14px] lg:text-[16px] text-[#26DDF9] aeonik_medium leading-[24px]'
                                                onClick={handleClaim}
                                                style={{ minWidth: '100px' }}
                                            >
                                                {isLoading ? (
                                                    <span className="flex items-center">
                                                        <svg
                                                            className="animate-spin mr-2 h-5 w-5 text-[#26DDF9]"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            fill="none"
                                                            viewBox="0 0 24 24"
                                                        >
                                                            <circle
                                                                className="opacity-25"
                                                                cx="12"
                                                                cy="12"
                                                                r="10"
                                                                stroke="currentColor"
                                                                strokeWidth="4"
                                                            ></circle>
                                                            <path
                                                                className="opacity-75"
                                                                fill="currentColor"
                                                                d="M4 12a8 8 0 018-8v8h8a8 8 0 01-8 8v-8H4z"
                                                            ></path>
                                                        </svg>
                                                        Wait...
                                                    </span>
                                                ) : (
                                                    'Claim'
                                                )}
                                            </span></a>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <div className='p-[24px] lg:p-[32px] bg-[#222222] rounded-[24px] mt-[16px] lg:mt-[24px]'>
                    <p className='text-[20px] lg:text-[24px] text-white aeonik_medium leading-[30px]'>{translation.Balances}</p>
                    <div className='pt-[12px] border-b-[1px] border-b-[#343434] pb-[12px]'>
                        {balancedList.map((item, i) => (
                            <div className='flex items-center justify-between mt-[12px]' key={i}>
                                <div className='flex items-center'>
                                    <img src={item.image} alt='logo' className='h-[32px] w-auto object-contain mr-[8px]' />
                                    <p className='lg:text-[18px] text-white aeonik_normal leading-[23px]'>{item.asset}</p>
                                </div>
                                <p className='lg:text-[18px] text-white aeonik_normal leading-[23px]'>{item.amount}</p>
                            </div>
                        ))}
                    </div>
                    <div className='flex items-center justify-between mt-[16px]'>
                        <p className='text-[#9b9c9d] text-[14px] lg:text-[16px] aeonik_normal leading-[24px]'>PikuG Locked Until</p>
                        <p className='text-white text-[20px] aeonik_normal leading-[25px]'>{lockedTime}</p>
                    </div>
                </div>
                <div className='p-[24px] lg:p-[32px] bg-[#222222] rounded-[24px] mt-[16px] lg:mt-[24px]'>
                    <p className='text-[20px] lg:text-[24px] text-white aeonik_medium leading-[30px]'>{translation.MyDAOActivity}</p>
                    <div className='mt-[24px]'>
                        <div className='flex items-center justify-between'>
                            <p className='text-white lg:text-[18px] aeonik_normal leading-[23px]'>Total DAO Votes</p>
                            <p className='text-white text-[20px] aeonik_normal leading-[25px]'>-</p>
                        </div>
                        <div className='flex items-center justify-between my-[16px]'>
                            <p className='text-white lg:text-[18px] aeonik_normal leading-[23px]'>DAO Vote Participation Amount</p>
                            <p className='text-white text-[20px] aeonik_normal leading-[25px]'>-</p>
                        </div>
                        <div className='flex items-center justify-between'>
                            <p className='text-white lg:text-[18px] aeonik_normal leading-[23px]'>vePikuG Delegated</p>
                            <p className='text-white text-[20px] aeonik_normal leading-[25px]'>-</p>
                        </div>
                        <div className='flex items-center justify-between mt-[16px]'>
                            <p className='text-white lg:text-[18px] aeonik_normal leading-[23px]'>vePikuG Delegated Percentage</p>
                            <p className='text-white text-[20px] aeonik_normal leading-[25px]'>-</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Claim;
